import { render } from "./CoursePlayer.vue?vue&type=template&id=2009b658&scoped=true"
import script from "./CoursePlayer.vue?vue&type=script&lang=js"
export * from "./CoursePlayer.vue?vue&type=script&lang=js"

import "./CoursePlayer.vue?vue&type=style&index=0&id=2009b658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2009b658"]])

export default __exports__